import { supabase } from '@shared/supabaseClient';

const KIOSK_TOKEN_KEY = 'kiosk_token';
const KIOSK_EXPIRES_KEY = 'kiosk_token_expires_at';
const KIOSK_DEPOT_KEY = 'kiosk_depot_id';
const KIOSK_DEVICE_KEY = 'kiosk_device_name';

export function getKioskToken() {
  return localStorage.getItem(KIOSK_TOKEN_KEY);
}

export function getKioskTokenExpiry() {
  return localStorage.getItem(KIOSK_EXPIRES_KEY);
}

export function getKioskDepotId() {
  return localStorage.getItem(KIOSK_DEPOT_KEY);
}

export function getKioskDeviceName() {
  return localStorage.getItem(KIOSK_DEVICE_KEY);
}

export function setKioskSession({ kiosk_token, expires_at, depot_id, device_name }) {
  if (kiosk_token) {
    localStorage.setItem(KIOSK_TOKEN_KEY, kiosk_token);
  }
  if (expires_at) {
    localStorage.setItem(KIOSK_EXPIRES_KEY, expires_at);
  }
  if (depot_id) {
    localStorage.setItem(KIOSK_DEPOT_KEY, depot_id);
  }
  if (device_name) {
    localStorage.setItem(KIOSK_DEVICE_KEY, device_name);
  }
}

export function clearKioskSession() {
  localStorage.removeItem(KIOSK_TOKEN_KEY);
  localStorage.removeItem(KIOSK_EXPIRES_KEY);
  localStorage.removeItem(KIOSK_DEPOT_KEY);
  localStorage.removeItem(KIOSK_DEVICE_KEY);
}

export function isKioskSessionExpired() {
  const expiresAt = getKioskTokenExpiry();
  if (!expiresAt) return true;
  return new Date(expiresAt).getTime() <= Date.now();
}

export async function kioskLogin({ pin, depot_id, device_name }) {
  const { data, error } = await supabase.functions.invoke('kiosk-login', {
    body: { pin, depot_id, device_name },
  });

  if (error) throw error;
  return data;
}
